// @flow
import StudyModel from "src/models/StudyModel";
import { entityReducer } from "src/utils/reducerUtils";

export const studies = entityReducer({ name: "studies", Model: StudyModel });
